import { UserService } from 'src/app/services/user-service/userservice';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import Plausible from 'plausible-tracker';
import { takeUntil } from "rxjs/operators"
import { Observable, Subject, timer } from "rxjs"
import { isPlatformBrowser } from '@angular/common';
import { getLocalStorageItem } from 'src/app/utils/browser-storage';

declare let gtag: Function;

@Injectable({
    providedIn: 'root'
})
export class TrackingService {
    private hasLoggedInitialInfo = false;
    private plausible: ReturnType<typeof Plausible> | null = null;
    private destroy$ = new Subject<void>()
    private readonly isBrowser: boolean;

    constructor(public router: Router, @Inject(PLATFORM_ID) platformId: object) {
        this.isBrowser = isPlatformBrowser(platformId);
        if (!this.isBrowser) {
            return;
        }

        this.plausible = Plausible({
            domain: environment.database_host, // Change to API_BASE_PLAUSILE_PROD_DOMAIN when in production (master branch)
            hashMode: true,
            trackLocalhost: true,
            apiHost: 'https://tracking.bimswarm.online'
        });
        this.plausible.trackPageview({ url: this.router.url });
    }

    public trackPageView(url: string): void {
        this.plausible?.trackPageview({ url });
    }

    public trackEvents(event: string): void {
        this.plausible?.trackEvent(event);
    }

    public trackEventsWithProps(event: string, props: {}): void {
        this.plausible?.trackEvent(event, { props: props });
    }

    delayedAction(delayTime = 100): Observable<void> {
        return new Observable<void>((observer) => {
            const timerSubscription = timer(delayTime)
                .pipe(takeUntil(this.destroy$))
                .subscribe(() => {
                    observer.next()
                    observer.complete()
                })

            return () => {
                timerSubscription.unsubscribe()
            }
        })
    }

    cancelDelay() {
        this.destroy$.next()
        this.destroy$.complete()
    }

    public initGoogleAnalytics() {
        if (!this.isBrowser) {
            return;
        }

        if (
            getLocalStorageItem('hasTrackingConsent') === 'true' &&
            !this.hasLoggedInitialInfo
        ) {
            if (this.router != null) {
                this.router.events.subscribe((event) => {
                    if (event instanceof NavigationEnd) { }
                });
            }
            else { }
            this.hasLoggedInitialInfo = true;
        }
    }

    public eventEmitter(
        eventName: string,
        eventCategory: string,
        eventAction: string,
        eventLabel: string = null,
        eventValue: number = null
    ): void {
        if (!this.isBrowser) {
            return;
        }

        if (getLocalStorageItem('hasTrackingConsent') == 'false') {
            return;
        }
    }
}
